export default __webpack_public_path__ + "static/lg-bf777547767a43caa1103a34f2887389.png";